export const contentRoute = '/content';
